import type { IconSvgObject } from './types';

const LayoutTable01Icon: IconSvgObject = [
  ["path", { d: "M3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28248 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28248 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 9L21.5 9", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 21.5L16 2.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8 21.4998L8 2.49976", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default LayoutTable01Icon;
